export default {
  init() {},
  finalize() {
    $('#btnLoadMore').on('click', function () {

      let page = $(this).data('page') * 1;
      const data = {
        action: 'search_next_page',
        page: page,
        search: $(this).data('search'),
      };

      const btn = $(this);
      const text = $(this).text();
      btn.attr('disabled', true);
      btn.text('A carregar ...');

      $.post('/wp-admin/admin-ajax.php', data, function (response) {
        if(response == ''){
          $('.pagination-more').slideUp();
          return;
        }

        page++;
        $('.products-container').append(response);
        btn.data('page', page);
        btn.attr('disabled', false);
        btn.text(text);
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search.js